import { isCancel as h, AxiosError as p } from "axios";
import { AccessDenied as u } from "./index4.mjs";
import { BadRequest as R, BadRequestWithViolations as E } from "./index5.mjs";
import { ConflictError as g } from "./index6.mjs";
import { FailedDependency as l } from "./index9.mjs";
import { InternalError as k } from "./index10.mjs";
import { invalidTokenErrorMessages as T } from "./index11.mjs";
import { LockedError as y } from "./index12.mjs";
import { MaintenanceError as q } from "./index13.mjs";
import { NetworkError as F } from "./index14.mjs";
import { NotFound as c } from "./index15.mjs";
import { PayloadTooLarge as N } from "./index16.mjs";
import { UnauthorizedResponse as A } from "./index17.mjs";
import { UnprocessableContentError as M } from "./index18.mjs";
const O = (a, n) => {
  let r = !1, o = [];
  const w = () => a.post("/api/user/token/regenerate"), d = (t) => {
    o.push(t);
  }, f = () => {
    o.forEach((t) => t()), o = [];
  }, m = async (t) => {
    const e = t.config;
    if (!r) {
      r = !0;
      try {
        return await w(), r = !1, f(), await a(e);
      } catch (s) {
        throw r = !1, o = [], s;
      }
    }
    return new Promise((s) => {
      d(() => {
        s(a(e));
      });
    });
  };
  return async (t) => {
    if (h(t))
      throw t;
    if (t = t, t.code === p.ERR_NETWORK)
      throw new F();
    const e = t.response;
    if (!e)
      throw t;
    switch (e.status) {
      case 400:
        throw "errors" in e.data ? new R(e.data) : new E(e.data);
      case 401:
        if (T.includes(e.data.message))
          return await m(t);
        {
          const i = e.data.redirect || e.data.location;
          if (i)
            throw new A(i);
          n == null || n.error("Unauthorized response", e.data);
        }
        break;
      case 403:
        throw new u();
      case 404:
        throw new c(c.isNotFoundResponse(e.data) ? e.data : void 0);
      case 409:
        throw new g(e.data);
      case 413:
        throw new N();
      case 422:
        throw new M(e.data);
      case 423:
        throw new y();
      case 424:
        throw new l(e.data.title);
      case 503:
        throw new q();
      case 500:
      case 502:
        throw new k();
    }
    throw t;
  };
};
export {
  O as getErrorMapper
};
